import { countToArray, onlyUnique, positionNumberToText, pushX } from "Utility";
import { DriverRoundTime } from "./DriverRoundTime";
import { TrackTableCell } from "./styles";
import { RoundTime } from "model/Match/Track/RoundTime";
import { JSX } from "react";

interface Props {
  roundTimes: RoundTime[][];
  tournamentId: string;
  showPosition: boolean;
  padding?: number;
  borderIdxs?: number[];
  alternateBackground?: boolean;
  frozen?: boolean;
}

export const RoundTimeRows = ({
  roundTimes,
  tournamentId,
  showPosition,
  padding,
  borderIdxs,
  alternateBackground,
  frozen,
}: Props) => {
  const driverIds = roundTimes
    .flatMap((r) => r.map((d) => d.driverId))
    .filter(onlyUnique);

  if (roundTimes.length === 0) {
    return <></>;
  }

  const maxPosition = Math.max(
    ...roundTimes.flatMap((r) => r.map((t) => t.position))
  );
  const positions = countToArray(maxPosition);

  const paddingCells: JSX.Element[] = [];
  pushX(<TrackTableCell frozen={frozen} />, padding ?? 0, paddingCells);
  return (
    <>
      {positions.map((pos) => {
        return (
          <tr>
            {paddingCells}
            {showPosition && (
              <TrackTableCell frozen={frozen} frozenOffset={true}>
                {positionNumberToText(pos)}
              </TrackTableCell>
            )}
            {roundTimes.map((r, i) => {
              const posRoundTime = r.find((r) => r.position === pos);
              if (!posRoundTime) {
                return (
                  <>
                    <TrackTableCell
                      leftBorder={borderIdxs?.includes(i) ?? false}
                      alternateBackground={
                        alternateBackground === true && i % 2 === 1
                      }
                    />
                    <TrackTableCell
                      alternateBackground={
                        alternateBackground === true && i % 2 === 1
                      }
                    />
                  </>
                );
              }

              return (
                <DriverRoundTime
                  driverId={posRoundTime.driverId}
                  tournamentId={tournamentId}
                  finishTimeMs={posRoundTime.finishTimeMs}
                  leftBorder={borderIdxs?.includes(i) ?? false}
                  alternateBackground={
                    alternateBackground === true && i % 2 === 1
                  }
                />
              );
            })}
          </tr>
        );
      })}
    </>
  );
};

interface Props2 {
  roundTimes: { [driverId: string]: number }[];
  tournamentId: string;
  showPosition: boolean;
  maxPosition: number;
  padding?: number;
  borderIdxs?: number[];
  alternateBackground?: boolean;
}

export const RoundTimeRows2 = ({
  roundTimes,
  tournamentId,
  showPosition,
  maxPosition,
  padding,
  borderIdxs,
  alternateBackground,
}: Props2) => {
  const driverIds = roundTimes
    .flatMap((r) => Object.keys(r))
    .filter(onlyUnique);

  if (roundTimes.length === 0) {
    return <></>;
  }

  const positions = countToArray(maxPosition);
  const paddingCells: JSX.Element[] = [];
  pushX(<TrackTableCell />, padding ?? 0, paddingCells);

  const orderedRoundDriverIds = roundTimes.map((r) =>
    Object.keys(r).sort((a, b) => {
      const aTime = r[a];
      const bTime = r[b];
      if (aTime === bTime) {
        return a.localeCompare(b);
      }

      if (aTime < 0) {
        return 1;
      }

      if (bTime < 0) {
        return -1;
      }

      if (aTime === 0) {
        return 1;
      }
      if (bTime === 0) {
        return -1;
      }

      return aTime - bTime;
    })
  );

  return (
    <>
      {positions.map((pos) => {
        return (
          <tr>
            {paddingCells}
            {showPosition && (
              <TrackTableCell>{positionNumberToText(pos)}</TrackTableCell>
            )}
            {orderedRoundDriverIds.map((driverIds, idx) => {
              const driverId = driverIds[pos - 1];
              return (
                <DriverRoundTime
                  driverId={driverId}
                  tournamentId={tournamentId}
                  finishTimeMs={roundTimes[idx][driverId]}
                  leftBorder={borderIdxs?.includes(idx) ?? false}
                  alternateBackground={
                    alternateBackground === true && idx % 2 === 1
                  }
                />
              );
            })}
          </tr>
        );
      })}
    </>
  );
};
